import { STORE_FEATURE_SECTIONS } from '../data/storeFeatureSections.data';
import { StoreFeatureSection } from './StoreFeatureSection';

export function StoreFeatureSections() {
  return (
    <>
      {STORE_FEATURE_SECTIONS.map((section) => (
        <StoreFeatureSection key={section.variant} section={section} />
      ))}
    </>
  );
}
